export default [
	/* {
    id: 2,
    msg: "Большой выбор",
    // price: "1 499 000 руб.",
    line_through: false,
    line_through_fos: false,
  },
  {
    id: 1,
    msg: "Только 25 а/м по акции",
    price: "1 463 700 руб.",
    line_through: false,
    line_through_fos: true,
  },
	{
    id: 4,
    msg: "Только 7 а/м по акции",
    price: "2 074 000 руб.",
    line_through: false,
    line_through_fos: true,
  },
  {
    id: 3,
    msg: "Осталось 5 а/м по акции",
    price: false,
    line_through: false,
    line_through_fos: true,
  }, */
];
